export default "__VITE_ASSET__DB_dnR5Y__"